import { ColumnsContext, UpdateConfig } from 'components/Table';
import { useContext, useCallback } from 'react';

export const useUpdateColumnsFromPreference = () => {
  const { setColumns } = useContext(ColumnsContext);

  const updateColumnsFromPreference = useCallback(
    (newColumns: UpdateConfig[]) => {
      setColumns((prev) => {
        const updatedColumns = [...prev];
        newColumns.forEach((newColumn) => {
          const existingColumnIndex = prev.findIndex((column) => column.name === newColumn.name);
          if (existingColumnIndex === -1) {
            // if the column doesn't exist in our current list of columns, we'll assume it was removed.
            // so we don't need to update it.
            return;
          }

          const updatedColumn = {
            ...prev[existingColumnIndex],
          };
          updatedColumn.order = newColumn.order;
          updatedColumn.visible = newColumn.visible;
          updatedColumns[existingColumnIndex] = updatedColumn;
        });
        return updatedColumns;
      });
    },
    [setColumns]
  );
  return { updateColumnsFromPreference };
};
